
<div class="title">{{ title }}</div>
<div class="value">{{ label || '-' }}</div>
